// extracted by mini-css-extract-plugin
module.exports = {"container":"StartUpCardList_container__3Slbc","sending":"StartUpCardList_sending__2Bh7G"};